"use client"

import { useEffect } from "react"
import { useSearchParams } from "next/navigation"
import { trackFaqPageViewed } from "@/lib/tracking"

export function FAQPageTracker() {
  // eslint-disable-next-line react-doctor/nextjs-no-use-search-params-without-suspense
  const searchParams = useSearchParams()

  useEffect(() => {
    const entrySource = searchParams.get("entry") || "direct"
    trackFaqPageViewed(entrySource)
  }, [searchParams])

  return null
}